var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticStyle: { width: "100%", "margin-top": "1%" } },
        [
          _c("GridComponent", {
            ref: "gridComponent",
            staticClass: "ag-theme-material",
            attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }